import LoginMain from "./../../components/login/Login_main";
import Topbar from "./../../components/main_topbar/Topbar.jsx";
// import style from "./login.module.css";

function Login() {
    return (
        <>
            <Topbar />
            <LoginMain />
        </>
    );
}

export default Login;
